import {
  TApplyChecklistTemplate,
  TApplyChecklistTemplateUi,
  TChecklistTemplate,
  TChecklistTemplateItem,
  TChecklistTemplateItemUi,
  TChecklistTemplateSave,
  TChecklistTemplateSaveUi,
  TChecklistTemplateUi,
} from 'data/types/checklistTemplate.types';
import { TCreateConverter, TFetchConverter } from 'data/types/converter.types';
import moment from 'moment';
import { getDateTimeFormats } from 'helpers/utils';

const checklistTemplateItemConverter: TFetchConverter<
  TChecklistTemplateItemUi,
  TChecklistTemplateItem
> = {
  fromDb: data => {
    return {
      id: data.id,
      description: data.description,
      order: data.order,
    };
  },
};

export const checklistTemplateConverter: TFetchConverter<
  TChecklistTemplateUi,
  TChecklistTemplate
> = {
  fromDb: data => {
    return {
      id: data.id,
      name: data.name,
      creationDateTime: data.creationDateTime,
      // Pre-formatted for the table's "Date Created" column, using the org's locale format like
      // the ticket/phase converters do.
      creationDate: data.creationDateTime
        ? moment(data.creationDateTime).format(getDateTimeFormats().dateFormat)
        : '',
      creator: data.creator,
      items: (data.items || []).map(item =>
        checklistTemplateItemConverter.fromDb(item),
      ),
      itemCount: data.itemCount ?? (data.items || []).length,
      canModify: !!data.canModify,
    };
  },
};

export const checklistTemplateSaveConverter: TCreateConverter<
  TChecklistTemplateSaveUi,
  TChecklistTemplateSave
> = {
  toDb: data => {
    return {
      name: data.name.trim(),
      // Blank rows are dropped here as well as on the backend, so an empty trailing row the user
      // never filled in does not become an item.
      items: data.items.map(item => item.trim()).filter(item => !!item),
    };
  },
};

export const applyChecklistTemplateConverter: TCreateConverter<
  TApplyChecklistTemplateUi,
  TApplyChecklistTemplate
> = {
  toDb: data => {
    return {
      templateId: data.templateId,
      parentId: data.parentId,
    };
  },
};
